import React from 'react';
import UploadDropZone from '../../../../../../common/DropZone/UploadDropZone';
import { BaseFile, UploadedFile } from '../../../../../../common/domain/upload';
import { GameLoaderType, UNITY_GAME_LOADERS } from '@crazygames/game-types/src/game-build/loader.type';

const MAX_GAME_FILE_SIZE = 500;

export function noFilesTextForGameFilesUpload(gameLoaderType: GameLoaderType | undefined | null): string {
  if (gameLoaderType && UNITY_GAME_LOADERS.includes(gameLoaderType)) {
    return 'Upload the "Build" and "StreamingAssets" folder if applicable. You should use Brotli compression. You can drag & drop folders here. ';
  }
  return 'Make sure your upload contains a "index.html" file for the game to run.';
}

export interface GameFilesUploadProps {
  gameLoaderType?: GameLoaderType;
  initialFiles?: UploadedFile[];
  onFilesModified: (files: UploadedFile[]) => void;
  onUploadsStarted?: () => void;
  onAllUploadsComplete?: () => void;
  onFilesToUploadSet: (files: BaseFile[]) => void;
  error?: boolean;
  isNonEditable?: boolean;
}

export const GameFilesUpload: React.FC<GameFilesUploadProps> = (props) => {
  const {
    initialFiles,
    gameLoaderType,
    onFilesModified,
    onAllUploadsComplete,
    onUploadsStarted,
    onFilesToUploadSet,
    error,
    isNonEditable,
  } = props;
  const dropDisabled = !gameLoaderType;
  const noFilesText = dropDisabled ? 'Select a game type first' : noFilesTextForGameFilesUpload(gameLoaderType);
  return (
    <div style={{ height: 200, width: '100%' }}>
      <UploadDropZone
        gameLoaderType={gameLoaderType}
        dropBehaviour="APPEND"
        dropDisabled={dropDisabled || isNonEditable}
        noFilesText={noFilesText}
        onFilesModified={(files) => onFilesModified(files)}
        initialFiles={initialFiles}
        maxFileSize={MAX_GAME_FILE_SIZE}
        onAllUploadsComplete={onAllUploadsComplete}
        onUploadsStarted={onUploadsStarted}
        onFilesToUploadSet={onFilesToUploadSet}
        error={error}
        isNonEditable={isNonEditable}
      />
    </div>
  );
};
